<template>
	<div class="w-full flex flex-wrap bg-white rounded-lg shadow-sm px-6 py-2 mt-8 py-4 overflow-hidden">
        <label class="bg-gray-100 w-full flex items-center justify-center" :class="{'h-24 sm:w-24': sm, 'h-32 sm:w-32': !sm, 'cursor-pointer': !loading && docs.length < maxDocs}">
        	<loaderIco class="h-8 w-8 text-gray-400 font-bold mx-auto" v-if="loading" />
            <svg v-else-if="docs.length < maxDocs" xmlns="http://www.w3.org/2000/svg" class="h-8 w-8 text-gray-400 font-bold mx-auto" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 4v16m8-8H4" />
            </svg>
            <svg v-else xmlns="http://www.w3.org/2000/svg" class="h-8 w-8 text-gray-400 font-bold mx-auto" fill="none" viewBox="0 0 24 24" stroke="currentColor">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M18.364 18.364A9 9 0 005.636 5.636m12.728 12.728A9 9 0 015.636 5.636m12.728 12.728L5.636 5.636" />
            </svg>
            <input v-if="!loading && docs.length < maxDocs" type='file' class="hidden" accept="application/pdf" @change="uploadFile"/>
        </label>
        <div class="flex-1 text-left sm:px-6 items-center" :class="{'mt-2': !sm}">
            <label class="font-bold" :class="{'text-sm': sm}">{{ title }}</label>
            <p class="mt-2" :class="{'text-sm': sm}">{{ text }}</p>
            <p v-if="loading" class="font-bold text-red mt-2 text-xs">Caricamento: {{ uploadValue.toFixed() + "%" }}</p>            
        </div>
        <div v-if="docs.length" class="w-full flex flex-col mt-6">
	        <div class="-my-2 overflow-x-auto sm:-mx-6 lg:-mx-8">
	            <div class="py-2 align-middle inline-block min-w-full sm:px-6 lg:px-8">
	                <div class="overflow-hidden border-b border-gray-200 sm:rounded-lg">
	                    <table class="min-w-full divide-y divide-gray-200">
	                        <thead class="bg-gray-50">
	                            <tr>
	                                <th scope="col" class="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">File</th>
	                                <th scope="col" class="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">{{ $t("Caricato il") }}</th>
	                                <th scope="col" class="relative px-6 py-3">
	                                    <span class="sr-only">{{ $t("Rimuovi") }}</span>
	                                    <span class="sr-only">{{ $t("Mostra") }}</span>
	                                </th>
	                            </tr>
	                        </thead>
	                        <tbody class="bg-white divide-y divide-gray-200">
	                            <tr v-for="d, i in docs" :key="i">
	                                <td class="px-6 py-4 whitespace-nowrap text-left">
	                                    <div class="text-xs font-medium text-gray-900">
	                                        {{ d.name }}
	                                    </div>
	                                    <div class="text-xs text-gray-500">
	                                        {{ parseFloat(d.size/1024000).toFixed(2) }}Mb
	                                    </div>
	                                </td>
	                                <td class="px-6 py-4 whitespace-nowrap text-left">
	                                    <span class="px-2 inline-flex text-xs leading-5 font-semibold rounded-full bg-green-100 text-green-800">
	                                        {{ d.created|moment('dddd, D MMM') }}
	                                    </span>
	                                </td>
	                                <td class="px-6 py-4 whitespace-nowrap text-center text-sm font-medium">
	                                    <button @click="removeDoc(i)" class="text-indigo-600 hover:text-indigo-900 mr-2 font-medium">{{ $t("Rimuovi") }}</button> |
	                                    <a :href="d.url" target="_blank" class="ml-2">{{ $t("Mostra") }}</a>
	                                </td>
	                            </tr>
	                            <!-- More people... -->
	                        </tbody>
	                    </table>
	                </div>
	            </div>
	        </div>
	    </div>
    </div>	
</template>
<script>
import loaderIco from '@/svg/loader.vue'
import { mapGetters } from 'vuex'
import firebase from 'firebase/app'
import "@firebase/auth";
import { db } from '@/db'
import { v4 as uuidv4 } from 'uuid'

export default {   
	props: ['type', 'sm', 'title', 'text','maxDocs', 'name'],
    data() {
        return {
            loading: false,
            fileData: null,
            uploadValue: 0,
        }
    },
    components: { loaderIco },
    computed: {
        ...mapGetters(["user"]),
        docs() {
        	return this.user.docs.filter(doc => doc.type == this.type)
        }
    },
    methods: {
        async uploadFile(event) {      
        	if(this.loading) return

        	this.loading = true                 
            this.uploadValue = 0;
            this.fileData = event.target.files[0];


            const filename = [this.user.uid.substring(0,6), this.name].join('-')
            const storageRef = firebase.storage().ref(`${filename}`).put(this.fileData);
            storageRef.on(`state_changed`, 
                snapshot => {
                    this.uploadValue = (snapshot.bytesTransferred / snapshot.totalBytes) * 100;
                }, 
                error => { 
                    console.log(error) 
                },
                () => {
                    this.uploadValue = 100;
                    storageRef.snapshot.ref.getDownloadURL().then(async (url) => {
                        // store user doc locally
                        const doc = {
                        	type: this.type,
                        	created: new Date(),
                            lastModified: this.fileData.lastModified,
                            name: filename,
                            size: this.fileData.size,
                            url
                        }                         
                        this.$store.commit('ADD_DOC', doc)
                        
                        // persist user additional data
                        await db.collection('users').doc(this.user.id).update({
                            docs: this.user.docs
                        })                        
                        this.loading = false      
                    });
                }
            )
        },
        async removeDoc(index) {
            this.$store.commit('REMOVE_DOC', index)            
            // persist user additional data
            await db.collection('users').doc(this.user.id).update({
                docs: this.user.docs
            })
        }
    }
}
</script>